import React, { useEffect, useState } from 'react';
import { Save, BookOpen } from 'lucide-react';
import { adminApi } from '../../api';
import { PageHeader, Field, Input, Textarea, Select, I18nInputs } from './AdminUI';

export default function AdminStories() {
  const [stories, setStories] = useState([]);
  const [cities, setCities] = useState([]);
  const [selected, setSelected] = useState('desenzano');
  const [form, setForm] = useState(null);

  const load = () => Promise.all([adminApi.stories(), adminApi.cities()]).then(([s, c]) => { setStories(s); setCities(c); });
  useEffect(() => { load(); }, []);

  useEffect(() => {
    const existing = stories.find(s => s.city_slug === selected);
    setForm(existing || { city_slug: selected, title: {it:'',en:''}, hero: '', paragraphs: {it:[''], en:['']} });
  }, [selected, stories]);

  const save = async (e) => {
    e.preventDefault();
    try {
      await adminApi.upsertStory(selected, form);
      alert('Storia salvata');
      load();
    } catch (err) { alert(err.response?.data?.detail || 'Errore'); }
  };

  const updateParagraphs = (lang, idx, value) => {
    const arr = [...(form.paragraphs?.[lang] || [])];
    arr[idx] = value;
    setForm({...form, paragraphs: {...form.paragraphs, [lang]: arr}});
  };
  const addPara = (lang) => setForm({...form, paragraphs: {...form.paragraphs, [lang]: [...(form.paragraphs?.[lang] || []), '']}});
  const rmPara = (lang, idx) => {
    const arr = [...(form.paragraphs?.[lang] || [])];
    arr.splice(idx, 1);
    setForm({...form, paragraphs: {...form.paragraphs, [lang]: arr}});
  };

  return (
    <div>
      <PageHeader title="Storie delle città" subtitle="Modifica il testo storico visualizzato in /citta/storia" />
      <div className="mb-4 max-w-xs">
        <Field label="Città">
          <Select value={selected} onChange={e => setSelected(e.target.value)}>
            {cities.map(c => <option key={c.slug} value={c.slug}>{c.name}</option>)}
          </Select>
        </Field>
      </div>
      {form && (
        <form onSubmit={save} className="bg-white rounded-xl border border-gray-200 p-6">
          <Field label="Titolo (per lingua)"><I18nInputs value={form.title} onChange={v => setForm({...form, title: v})} /></Field>
          <Field label="URL Immagine hero"><Input value={form.hero || ''} onChange={e => setForm({...form, hero: e.target.value})} /></Field>
          {form.hero && <img src={form.hero} alt="" className="w-full h-40 object-cover rounded-lg mb-4" />}

          {['it', 'en', 'de', 'fr', 'es', 'zh', 'ar'].map(lang => (
            <div key={lang} className="mb-6 border-t pt-4">
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-semibold text-sm text-gray-700">Paragrafi — {lang.toUpperCase()}</h3>
                <button type="button" onClick={() => addPara(lang)} className="text-xs text-[color:var(--yup-primary)] hover:underline">+ Aggiungi paragrafo</button>
              </div>
              {(form.paragraphs?.[lang] || []).map((p, idx) => (
                <div key={idx} className="flex gap-2 mb-2">
                  <Textarea rows={3} value={p} onChange={e => updateParagraphs(lang, idx, e.target.value)} className="flex-1" />
                  <button type="button" onClick={() => rmPara(lang, idx)} className="text-red-600 text-xs px-2">Rimuovi</button>
                </div>
              ))}
            </div>
          ))}

          <div className="flex justify-end gap-2 mt-6">
            <button type="submit" className="btn-primary flex items-center gap-2"><Save size={16}/> Salva storia</button>
          </div>
        </form>
      )}
    </div>
  );
}
